import { onScroll, scrollTop } from '../utils/scroll';
import { currentWindowHeight } from '../utils/windowResize';
import { scrollTo } from '../utils/scrollTo';

export function setupTimeline() {
    const timeline = document.querySelector('.timeline');
    let headerHeight;

    function gotoTimelineItem(e) {
        const item = e.currentTarget.hasAttribute('data-top') ? e.currentTarget : e.currentTarget.nextElementSibling;
        const scrollToPos = parseInt(item.getAttribute('data-top')) + 1/* + parseInt((headerHeight / 2))*/;

        scrollTo(scrollToPos);
    }

    /*function enterItem(e) {
        const item = e.currentTarget;
        const header = item.previousElementSibling;

        if (header) {
            header.classList.add('js-hover');
        }
    }

    function leaveItem(e) {
        const item = e.currentTarget;
        const header = item.previousElementSibling;

        if (header) {
            header.classList.remove('js-hover');
        }
    }*/

    if (timeline) {
        const headers = Array.from(timeline.querySelectorAll('.h3'));
        const items = Array.from(timeline.querySelectorAll('.timeline__item'));

        if (headers.length == items.length && headers.length > 0) {
            headerHeight = headers[0].offsetHeight;

            items.forEach(function(item, index) {
                const itemTop = parseInt(item.getBoundingClientRect().top) + parseInt(scrollTop) - parseInt(currentWindowHeight * 0.4)/* - parseInt(headerHeight / 2)*/;
                item.setAttribute('data-top', itemTop);
            });
        }

        onScroll(() => {
            items.forEach(function(item, index) {
                const itemTop = item.getAttribute('data-top');

                if (scrollTop > itemTop) {
                    item.classList.add('js-show');
                    headers[index].classList.add('js-show');

                    if (index > 0) {
                        headers[index - 1].classList.add('js-hide');
                        items[index - 1].classList.add('js-hide');
                    }
                } else {
                    if (index > 0) {
                        item.classList.remove('js-show');
                        headers[index].classList.remove('js-show');
                        headers[index - 1].classList.remove('js-hide');
                        items[index - 1].classList.remove('js-hide');
                    }
                }
            });
        });

        headers.forEach(function(header,index) {
            header.addEventListener('click', gotoTimelineItem);
            items[index].addEventListener('click', gotoTimelineItem);
        });

        /*items.forEach(function (item, index) {
            item.addEventListener('mouseenter', enterItem);
            item.addEventListener('mouseleave', leaveItem);
        });*/
    }
}